export default __webpack_public_path__ + "289bbe11597eb2be456e1db5e475c05c.png";